import { css } from "styled-components";

export const ghostStrokeStyle = css`
  background-color: var(--button-ghost-bg) !important;
  border: 1px solid var(--button-ghost-border);
  color: var(--text-light);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-small);

  svg path {
    fill: transparent !important;
    stroke: var(--text-light) !important;
  }

  &:hover {
    background-color: var(--button-ghost-bg-hover) !important;
    border: 1px solid var(--button-ghost-border-hover) !important;
    color: var(--text-light) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--text-light) !important;
    }
  }

  &:focus {
    outline: none !important;
    background-color: var(--button-ghost-bg) !important;
    border: 1px solid var(--button-ghost-border) !important;
    color: var(--text-light) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--text-light) !important;
    }
  }

  &:focus-visible {
    outline: 1px solid var(--button-ghost-focused-border) !important;
    box-shadow: 0px 0px 0px 2px var(--button-focused-shadow) !important;
  }

  &:active {
    background-color: var(--button-ghost-bg-clicked) !important;
    border-color: var(--button-ghost-border-clicked) !important;
  }

  &[disabled] {
    background-color: var(--button-ghost-bg) !important;
    border: 1px solid var(--button-ghost-border);
    color: var(--text-light);
    opacity: 0.7;

    &:hover {
      background-color: var(--button-ghost-bg) !important;
      border: 1px solid var(--button-ghost-border) !important;
      color: var(--text-light);
      opacity: 0.7;
    }
  }
`;
